var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47711 0 0 4.47711 0 10C0 15.5229 4.47711 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47711 15.5229 0 10 0Z",
    fill: "#40B3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8659 5.75235L13.0797 14.7577C13.0797 14.7577 12.8299 15.3823 12.143 15.0825L8.02125 11.9225L6.5225 11.1981L3.99953 10.3488C3.99953 10.3488 3.61234 10.2114 3.57484 9.91165C3.53734 9.61188 4.01203 9.44954 4.01203 9.44954L14.0414 5.51517C14.0414 5.51517 14.8658 5.15298 14.8658 5.75251",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70452 14.6565C7.70452 14.6565 7.58421 14.6453 7.43421 14.1706C7.28444 13.696 6.52249 11.198 6.52249 11.198L12.5801 7.35112C12.5801 7.35112 12.9299 7.13878 12.9174 7.35112C12.9174 7.35112 12.9798 7.38862 12.7924 7.56346C12.6051 7.73838 8.03382 11.8475 8.03382 11.8475",
    fill: "#D2E5F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60164 13.134L7.9714 14.6204C7.9714 14.6204 7.8439 14.7171 7.70453 14.6565L8.01672 11.8955",
    fill: "#B5CFE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTelegram);
export default __webpack_public_path__ + "static/media/logo-telegram.42e1a31a.svg";
export { ForwardRef as ReactComponent };